import React from "react";
import AsteroidImpactDashboard from "./pages/AsteroidImpactDashboard";

export default function App() {
    return <AsteroidImpactDashboard />;
}
